import React from "react";
import { Container, SliderFullscreen, FullcreenSlide, FullcreenImage } from "./styled/photos";
function Photos(_a) {
    var _b = _a.initialIndex, initialIndex = _b === void 0 ? 0 : _b, _c = _a.photos, photos = _c === void 0 ? [] : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? "#eeeff1" : _d;
    return (React.createElement(Container, { backgroundColor: backgroundColor }, !!photos.length && (React.createElement(SliderFullscreen, { initialIndex: initialIndex }, photos.map(function (photo, index) { return (React.createElement(FullcreenSlide, { key: photo },
        React.createElement(FullcreenImage, { src: photo, alt: "Slide " + (index + 1) }))); })))));
}
export default Photos;
